import { action } from 'typesafe-actions'
import { Video } from '@models/video-content'
import {RequestData} from "@models/axios";


export const enum VideoFilesActionTypes {
    FETCH_REQUEST = '@@videoFiles/FETCH_REQUEST',
    FETCH_SUCCESS = '@@videoFiles/FETCH_SUCCESS',
    FETCH_ERROR = '@@videoFiles/FETCH_ERROR',

    DELETE_REQUEST = '@@videoFiles/DELETE_REQUEST',
    DELETE_SUCCESS = '@@videoFiles/DELETE_SUCCESS',
    DELETE_ERROR = '@@videoFiles/DELETE_ERROR',

    CREATE_REQUEST = '@@videoFiles/CREATE_REQUEST',
    CREATE_SUCCESS = '@@videoFiles/CREATE_SUCCESS',
    CREATE_ERROR = '@@videoFiles/CREATE_ERROR',

    UPDATE_REQUEST = '@@videoFiles/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@videoFiles/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@videoFiles/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = '@@videoFiles/FETCH_ITEM_REQUEST',
    FETCH_ITEM_SUCCESS = '@@videoFiles/FETCH_ITEM_SUCCESS',
    FETCH_ITEM_ERROR = '@@videoFiles/FETCH_ITEM_ERROR',
}


export const fetchRequest = (data:RequestData) => action(VideoFilesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Video[]) => action(VideoFilesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(VideoFilesActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(VideoFilesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:any) => action(VideoFilesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(VideoFilesActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(VideoFilesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Video[]) => action(VideoFilesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(VideoFilesActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(VideoFilesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Video[]) => action(VideoFilesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(VideoFilesActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data:RequestData) => action(VideoFilesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Video[]) => action(VideoFilesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(VideoFilesActionTypes.FETCH_ITEM_ERROR, message);